import axios from 'axios';
import { ListCertificatesQsp, StateType } from './legacy-model.js';
export const pendingApprovalCertificates = async (root, certificate, token) => axios
    .get(`${root}/legacy/certs-index/list`, {
    headers: { Authorization: 'Anonymous view' },
    params: {
        [ListCertificatesQsp.token]: `${certificate}:${token}`,
        [ListCertificatesQsp.currentStateIn]: StateType.APPROVAL_REQUESTED,
    },
})
    .then((output) => output.data);
//# sourceMappingURL=certs-index.js.map